<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-sm-3 col-12">
              <h2 class="card-title-desc">Customer Orders</h2>
            </div>
<!--            <div class="col-3 " v-if="checkForPermission(send_warehouse_email_permission)">-->
<!--              <b-button :disabled="ordersLoading" variant="dark" size="sm" class="py-2 text-white" @click="sendEmailToWarehouse">Send Email To Warehouse</b-button>-->
<!--            </div>-->
          </div>
          <div class="row mb-2">
            <div class="col-sm-2 col-12 mb-2" v-if="checkForPermission(send_warehouse_email_permission)">
              <b-button :disabled="ordersLoading" variant="dark" size="sm" class="py-2 text-white" @click="sendEmailToWarehouse">Send Email To Warehouse</b-button>
            </div>
            <div class="col-sm-10 col-12 mb-2" v-if="checkForPermission(send_warehouse_email_permission)">
              <div class="row">
                <div class="col-sm-4 col-12">
                  <div class="flex-nowrap input-group mb-1">
                    <label class="input-group-text bg-dark text-white">Delivery Date</label>
                    <date-picker v-model="ordersForCollectionDate" :disabled-date="datePickerDisabledBeforeTodayAndAfterAWeek"></date-picker>
                  </div>
                </div>
                <div class="col-sm-4 col-12">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-dark text-white">Warehouse</label>
                    <select class="form-select" v-model="offshoreWarehouse">
                      <option v-for="warehouse in warehouses?.objects" :key="warehouse.publicId" :value="warehouse.publicId">
                        {{ warehouse.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3 col-12" v-if="isUserStaff()">
                  <button v-if="httpLoading" class="btn btn-dark me-1 w-100" :disabled="httpLoading">Loading</button>
                  <button v-else class="btn btn-dark me-1 w-100" @click="downloadOffshoreOrders">Download Offshore Orders</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-sm-5 col-12 mt-2" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-md-flex d-sm-inline">
                <date-picker v-model="ordersSelectedDate" range class="me-3 mb-1" placeholder="Select Dates for Report"></date-picker>
                <button class="btn btn-info me-1 w-100 mb-1" @click="downloadOrderSalesReport">Download Order Sales Report</button>
              </div>
            </div>
            <!-- <div class="col-sm-5 col-12 mt-2" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-flex">
                <date-picker v-model="cancelledSelectedDate" range class="me-3" placeholder="Select Dates for Report"></date-picker>
                <button class="btn btn-info me-1 w-100" @click="downloadCancelledOrdersReport">Download Cancelled Orders Report</button>
              </div>
            </div> -->
          </div>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :has-pagination="false" :current-page="currentPage" @onSearch="searchFn">
              <template v-slot:actions="slotProps">
                <div class="button-items" v-if="checkForPermission(view_single_order_permission)">
                  <b-button v-if="slotProps.row.status.orderStatusName === 'Open'" variant="danger" size="sm" class="py-1 text-white" @click="customizeOrder(slotProps.row.publicId)">
                    Customize Order
                  </b-button>
                  <b-button variant="info" size="sm" class="py-1 text-white" @click="viewOrderInvoice(slotProps.row.publicId)">
                    View Invoice
                  </b-button>
                </div>
              </template>
              <div class="row mb-2">
                <div class="col-sm-2 col-12">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Status</label>
                    <select class="form-select" @change="statusFilter($event)">
                      <option value="all" selected>All</option>
                      <option v-for="orderStatus in orderStatusRecords?.objects" :key="orderStatus.publicId" :value="orderStatus.publicId">
                        {{ orderStatus.orderStatusName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3 col-12">
                  <div class="flex-nowrap input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Delivery Date</label>
                    <date-picker v-model="selectedDate"  range @change="deliveryDateFilter"></date-picker>
                  </div>
                </div>
                <div class="col-sm-2 col-12" v-if="isUserStaff()">
                  <button class="btn btn-primary me-1 w-100" @click="downloadFilteredReport">Download Report of Filtered Orders</button>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import { ALL_CUSTOMER_ORDERS, ALL_ORDER_STATUS_RECORDS } from "@/gql/orders";
import { ALL_WAREHOUSES } from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
import {getDatesInRange} from "@/filters/datesInRange";
import {mapActions, mapGetters} from "vuex";
import {errorToast, successToast} from "@/components/successToast";
import moment from "moment/moment";
import {downloadFileConfig} from "@/filters/downloadFileConfig";

export default {
  page: {
    title: "Customer Orders",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "customer-orders",
  data() {
    return {
      title: "Customer Orders",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Customer Orders",
          active: true
        }
      ],
      view_single_order_permission: permissions.view_single_order_permission,
      send_warehouse_email_permission: permissions.send_warehouse_email_permission,
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      orderStatus: [],
      selectedDate: "",
      cancelledSelectedDate: "",
      ordersSelectedDate: "",
      ordersForCollectionDate: "",
      deliveryDates: [],
      offshoreWarehouse: '',
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.institutionId.name',
          label: 'Customer'
        },
        {
          field: 'customer.name',
          label: 'Branch'
        },
        {
          field: 'orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'orderStatus',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      orders: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderStatus: this.orderStatus,
          deliveryDates: this.deliveryDates
        }
      }
    },
    orderStatusRecords: {
      query: ALL_ORDER_STATUS_RECORDS,
      variables() {
        return {
          page: 0,
          perPage: 30,
        }
      }
    },
    warehouses: {
      query: ALL_WAREHOUSES,
      variables() {
        return {
          page: 0,
          perPage: 30,
          isActive: true,
        }
      }
    },
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading',
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    }),
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      sendWarehouseEmail: 'orders/sendWarehouseEmail',
      generateOrderSalesReport: 'http/generateOrderSalesReport',
      generateCancelledOrdersReport: 'http/generateCancelledOrdersReport',
      generateOffshoreOrdersForDelivery: 'http/generateOffshoreOrdersForDelivery',
    }),
    viewOrderInvoice(public_id){
      this.$router.push({path: routeItems.customer_order_invoice_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch(() => {})
    },
    customizeOrder(public_id){
      this.$router.push({path: routeItems.customize_order_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch(() => {})
    },
    searchFn(data){
      this.searchKeyword = data
    },
    statusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.orderStatus = []
      }else {
        this.orderStatus = [value]
      }
    },
    deliveryDateFilter(){
      if(this.selectedDate[0] === null){
        this.deliveryDates = []
      }else{
        this.deliveryDates = getDatesInRange(this.selectedDate[0], this.selectedDate[1])
      }
    },
    datePickerDisabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
    },
    async sendEmailToWarehouse(){
      await this.sendWarehouseEmail().then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
        }
      })
    },
    async downloadOrderSalesReport(){
      if (this.ordersSelectedDate !== ''){
        const start = moment(this.ordersSelectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.ordersSelectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateOrderSalesReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Orders Sales ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating order sales report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    },
    async downloadFilteredReport(){
      const filters = {'status': this.orderStatus, 'delivery_dates': this.deliveryDates, 'search': this.searchKeyword}

      const response = await this.generateOrderSalesReport({'filter': filters})
      if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        downloadFileConfig(response, `Sales Report Filtered - ${moment().format('YYYY-MM-DD')}.xlsx`)
      }else {
        errorToast('Error generating filtered sales report')
      }

    },
    async downloadCancelledOrdersReport(){
      if (this.cancelledSelectedDate !== ''){
        const start = moment(this.cancelledSelectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.cancelledSelectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateCancelledOrdersReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Cancelled Orders ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating cancelled orders report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    },
    async downloadOffshoreOrders() {
      if (this.ordersForCollectionDate !== '') {
        const date = moment(this.ordersForCollectionDate).format('YYYY-MM-DD')
        const response = await this.generateOffshoreOrdersForDelivery({"date": date, "warehouse": this.offshoreWarehouse})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `${date}-OrdersForDelivery.xlsx`)
        }else {
          errorToast('Error getting orders for delivery')
        }
      } else {
        errorToast('Date selection cannot be blank')
      }
    },

  },
}
</script>

<style scoped>

</style>
